<section class="w3l-form-25">
  <div class="w3l-form-25">
    <BR>
   <label style="width: 250px;">   </label>
   <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
   <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
 </div>
 <div class="form-inner-cont">
  <div class="w3l-form-25">
      <h1>{{'Accounting Department Data' | translate }}</h1>
      <p>{{'Enter Insurance Companies Information' | translate }}</p>
      <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Insurance Companies Information' | translate }}</h1>
  </div>
</div>

<div id="w3l-appointment">
  <div class="wrapper">
  <div class="doctor-appointment">
    <form action="#" method="post" >

        <div class="appointment-form-field">
            <label style="width: 20%;">{{ 'Code' | translate }}</label>
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="OpenDialog()"></span>     
              <input type="number" name="clsscSerial"  style="width: 20%;" [(ngModel)]="insid" (change)="RetriveCompany()">
          </div>
        <div class="appointment-form-field">
          <label style="width: 20%;">{{ 'Name' | translate }}</label>
          <input type="text" name="classname" style="width: 65%;" [(ngModel)]="insenglishname" maxlength="150ch">
        </div>
         <div class="appointment-form-field">
          <label style="width: 20%;">{{ 'Arabic Name' | translate }}</label>
          <input type="text" name="classaname" style="width: 65%;" [(ngModel)]="insarabicname" maxlength="150ch">
        </div>

      <div class="appointment-form-field">
        <label style="width: 20%;">{{ 'Address 1' | translate }}</label>
        <input type="text" name="contactPerson"  style="width: 65%;" [(ngModel)]="insaddress" >
      </div>
     


      <div class="appointment-form-field">
        <label style="width: 20%;">{{ 'Telephone 1' | translate }}</label>
        <input type="text" name="tel1"  style="width: 20%;" [(ngModel)]="insphone1" maxlength="100ch" >
        <label style="width: 5%;"></label>
        <label style="width: 20%;">{{ 'Telephone 2' | translate }}</label>
        <input type="text" name="tel2"  style="width: 20%;" [(ngModel)]="insphone2" maxlength="100ch">
        
      </div>
      <div class="appointment-form-field">
        <label style="width: 20%;">{{ 'email' | translate }}</label>
        <input type="text" name="contactPersonemail"  style="width: 65%;" [(ngModel)]="insemail" maxlength="100ch">
      </div>
       <div class="appointment-form-field">
        <label style="width: 20%;">{{ 'Contact Person' | translate }}</label>
        <input type="text" name="contactPersonname"  style="width: 65%;" [(ngModel)]="inscontatpersonname" maxlength="150ch" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 20%;">{{ 'Contact Person Title' | translate }}</label>
        <input type="text" name="contactPersontitle"  style="width: 65%;" [(ngModel)]="inscontatpersontitle" maxlength="150ch">
      </div>

     <div class="appointment-form-field">
        <label style="width: 20%;">{{ 'Mobile' | translate }}</label>
        <input type="text" name="contactPersonmobile"  style="width: 25%;" [(ngModel)]="inscontatpersonmobile" maxlength="100ch" >
           <label style="width: 5%;"></label>
        <label style="width: 10%;">{{ 'App. email' | translate }}</label>
        <input type="text" name="fax"  style="width: 25%;" [(ngModel)]="insapprovalsemail" maxlength="100ch">
      </div>

  

      <div class="appointment-form-field">
        <label style="width: 20%;">{{ 'Start Date' | translate }}</label>
        <input type="date" name="email"  style="width: 25%;" [(ngModel)]="insstartdate" >
         <label style="width: 5%;"></label>
         <label style="width: 10%;">{{ 'End Date' | translate }}</label>
           <input type="date" name="email"  style="width: 25%;" [(ngModel)]="insenddate" >
      </div>
      
      <BR>
        <table>
          <thead>
              <tr >
                  <th style="width: 30%;"></th>
                  <th style="width: 30%;align-self: center;"></th>
                  <th style="width: 30%;"></th>
              </tr>
          </thead>
          <tbody>

              <tr>
                <td data-column="Item ID" style="text-align: center;"> </td>
                <td data-column="Item Name" style="text-align: center;"> <label style="font-size: large;font-weight: bold;text-align: center;">{{'Logo' | translate}}</label></td>
                <td data-column="Item Name"></td>
            </tr>
              <tr>
                <td data-column="Item ID"> </td>
                <td data-column="Item Name" *ngIf= "!wk_Acc_Not"><img src="assets/images/Person.jpg"  alt="Item Image" width="250px" height="200px" style="border: 1px;border-style: double;"/></td>

                <td data-column="Item Name" *ngIf= "!wk_Acc_Not1"><img src="data:image/jpg;base64,{{myimage}}"  alt="Item Image" width="200px" height="200px" style="border: 1px;border-style: double;"/></td>
                <td data-column="Item Name"><input (change)="picked($event)" type="file" id="photo" name="photo" accept="image/*" style="width: 250px;"></td>
            </tr>

          </tbody>
        </table>

    </form>
  </div>
  </div>
</div>
<BR>
<BR>

  <BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px; font-weight: bold;" name="submit" (click)="submitContacts()">{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Delete" (click)="MesgDelete()">{{ 'Delete' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="New" (click)="NewData()">{{ 'New' | translate }}</button>
    <a href="Home">
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Back">{{ 'Home' | translate }}</button>
    </a>
    <label style="width: 25%;"></label>
  </form>
  <BR>
    <BR>

</section>




